/** Keep in sync with `.exec-dash` CSS vars in index.css (--exec-dash-ring-size, --exec-dash-ring-stroke). */
export const EXEC_DASH_RING_SIZE = 168;
export const EXEC_DASH_RING_STROKE = 14;
export const EXEC_DASH_RING_R = 68;
export const EXEC_DASH_RING_CX = EXEC_DASH_RING_SIZE / 2;
export const EXEC_DASH_RING_CY = EXEC_DASH_RING_SIZE / 2;
